<style lang="scss">
  .company-field-container {
    position: relative;
  }
</style>

<script>
  import { onMount } from "svelte";
  import { candidateStore, editContactStore } from "../../stores";
  import CompanyInput from "./components/CompanyInput.svelte";
  import {
    hasEditedCompanyStore,
    resetCompanyState,
    selectedCompanyStore,
  } from "./stores";

  onMount(() => {
    resetCompanyState();

    if ($candidateStore.companyId) {
      selectedCompanyStore.set({
        companyId: $candidateStore.companyId,
        name: $editContactStore.company,
        logo: $candidateStore.companyLogo || null,
      });
    }

    return resetCompanyState;
  });
</script>

<div class="company-field-container">
  <CompanyInput
    trailingImage={$selectedCompanyStore.companyId && !$hasEditedCompanyStore
      ? $selectedCompanyStore.logo
      : null}
    trailingImageAlt={$selectedCompanyStore.name || ""}
  />
</div>
